/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} User_Role_Remove_TitleInputs */

const vi_user_role_remove_title = /** @type {(inputs: User_Role_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bỏ vai trò ${i?.name}`)
};

/**

* @param {User_Role_Remove_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_role_remove_title = /** @type {((inputs: User_Role_Remove_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Role_Remove_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_role_remove_title(inputs)
});